<template>
    <div class="new-page-main" :style="dataDetailStyle">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
        </div>
        <!--数据展示切换-->
        <div class="school-data-tab-area">
            <Tabs type="card" @on-click="changeDataDetailsIndex">
                <TabPane label="教师" name="teacher"></TabPane>
                <TabPane label="学生" name="student"></TabPane>
            </Tabs>
        </div>
        <div v-if="dataDetailsIndex==1">
            <!--数据统计图-->
            <div class="data-statistics-img" ref="dataStatistics">
                <ul>
                    <li class="circle-data">
                        <div class="data">{{teaSummaryData[0].teaCount}}</div>
                        <div class="label">任课教师数</div>
                    </li>
                    <li class="circle-data" style="margin-right:0;">
                        <div class="data">{{teaSummaryData[0].teaWorkCount}}</div>
                        <div class="label">布置作业数</div>
                    </li>
                </ul>
            </div>
            <div class="new-data-table-main-wrap">
                <Table border stripe :columns="teacherColumns" :data="teacherData"
                       :row-class-name="rowClassName"></Table>
            </div>
            <!--分页-->
            <div class="new-bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
        <div v-else  ref="dataStatistics">
            <!--数据统计图-->
            <div class="data-statistics-img">
                <ul style="width:505px;">
                    <li class="circle-data">
                        <div class="data">{{studSummaryData.studentCount}}</div>
                        <div class="label">学生数</div>
                    </li>
                    <li class="circle-data">
                        <div class="data">{{studSummaryData.subRates}}%</div>
                        <div class="label">提交率</div>
                    </li>
                    <li class="circle-data" style="margin-right:0;">
                        <div class="data">{{studSummaryData.unSubRates}}%</div>
                        <div class="label">未提交率</div>
                    </li>
                </ul>
            </div>
            <div class="new-data-table-main-wrap">
                <Table border stripe :columns="studentColumns" :data="studentData"
                       :row-class-name="rowClassName"></Table>
            </div>
            <!--分页-->
            <div class="new-bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getTeacherStat,
        getTeacherRateList,
        getStudentRateList,
        getStudentRateMap
    } from "../../../../service/api.js";

    export default {
        name: "new-school-data-details",
        data () {
            return {
                resourceList: [],
                homeworkList: [],
                filters: {
                    schoolId: this.$route.query.schoolId == 0 ? '' : this.$route.query.schoolId,
                    classId: this.$route.query.classId,
                    startDate: this.$utils.getWeekStartDate() + ' 00:00:00',
                    endDate: this.$utils.getWeekEndDate() + ' 23:59:59',
                    timeSolt: 1,
                    keyWord: '',
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                dataDetailsIndex: 1,//默认显示教师详细情况
                teacherColumns: [
                    {
                        title: '序号',
                        key: 'rowNum',
                        align: "center"
                    },
                    {
                        title: '教师名称',
                        key: 'display_name',
                        align: "center"
                    },
                    {
                        title: '学科名称',
                        key: 'bank_name',
                        align: "center"
                    },
                    {
                        title: '布置作业份数',
                        key: 'subNub',
                        align: "center"
                    },
                    {
                        title: '布置作业次数',
                        key: 'freQuency',
                        align: "center"
                    },
                    {
                        title: '学生数',
                        key: 'students',
                        align: "center"
                    },
                    {
                        title: '提交学生数',
                        key: 'submit_stus',
                        align: "center"
                    },
                    {
                        title: '批改学生数',
                        key: 'complete_stus',
                        align: "center"
                    },
                    {
                        title: '作业提交率',
                        key: 'subRates',
                        align: "center"
                    },
                    {
                        title: '作业批改率',
                        key: 'correRate',
                        align: "center"
                    }
                ],
                studentColumns: [
                    {
                        title: '学生名称',
                        key: 'name',
                        align: "center"
                    },
                    {
                        title: '已提交',
                        key: 'subCount',
                        sortable: true,
                        align: "center"
                    },
                    {
                        title: '未提交',
                        key: 'unSubmittedCount',
                        sortable: true,
                        align: "center"
                    }
                ],
                teacherData: [],
                studentData: [],
                teaSummaryData: [],//教师情况总计集合
                studSummaryData: {},//学校情况总计集合
                dataDetailStyle:{
                    height:'0px'
                }
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.query.schoolCode,
                    }
                },
                {
                    title: this.$route.query.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部资源",
                    path: "",
                    name: "resourceList"
                },
                {
                    title: this.$route.query.className,
                    path: "",
                    name: "className"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 表格斑马纹
             */
            rowClassName (row, index) {
                if (index % 2 == 0) {
                    return 'ivu-table-stripe-even';
                } else return 'ivu-table-stripe-odd';
            },
            /**
             * 点击切换详细数据
             */
            changeDataDetailsIndex (name) {
                //点击切换至教师详情
                if (name === "teacher") {
                    this.dataDetailsIndex = 1;
                    //获取教师情况统计
                    this.getTeacherStat();
                    //获取各个教师详细信息
                    this.getTeacherRateList();
                }
                //点击切换至学生详情
                else {
                    this.dataDetailsIndex = 2;
                    //获取学生情况统计
                    this.getStudentRateMap();
                    //获取学生详细信息
                    this.getStudentRateList();
                }
                this.$nextTick(() => {
                    this.dataDetailStyle.height = 705+ this.$refs.dataStatistics.clientHeight+"px";
                })
            },
            /**
             * 获取教师情况统计
             */
            async getTeacherStat () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                };
                _this.teaSummaryData = await getTeacherStat(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
            },
            /**
             * 获取学生情况统计
             */
            async getStudentRateMap () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                };
                _this.studSummaryData = await getStudentRateMap(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
            },
            /**
             * 获取各个教师详细信息
             */
            async getTeacherRateList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await getTeacherRateList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.teacherData = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 获取学生详细信息
             */
            async getStudentRateList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    classId: _this.filters.classId,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await getStudentRateList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.studentData = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                if (this.dataDetailsIndex == 1) {
                    this.getTeacherRateList();
                } else {
                    this.getStudentRateList();
                }
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                if (this.dataDetailsIndex == 1) {
                    //获取各个教师详细信息
                    this.getTeacherRateList();
                } else {
                    //获取学生详细信息
                    this.getStudentRateList();
                }
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                //反选的情况
                // if (this.filters.timeSolt === type) {
                //     this.filters.timeSolt = 0;
                //     this.filters.startDate = '';
                //     this.filters.endDate = '';
                // } else {
                this.filters.timeSolt = type;
                // }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                }
                this.handleSearch();
            },
        },
        mounted () {
            //获取教师情况统计
            this.getTeacherStat();
            //获取各个教师详细信息
            this.getTeacherRateList();
            //求页面高度
            this.$nextTick(() => {
                this.dataDetailStyle.height = 705+ this.$refs.dataStatistics.clientHeight+"px";
            })

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .circle-data {
        background: url("../../../../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
    }
</style>

<style lang="scss">
    .school-data-tab-area {
        .ivu-tabs-bar {
            border-bottom: 0;
            background: #f2f5f3;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
            height: 40px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
            height: 40px;
            color: #00caaf;
        }

        .ivu-tabs-nav .ivu-tabs-tab:hover {
            color: #00caaf;
        }

        .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
            border-color: #dcdee2 !important;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
            height: 40px;
            margin-right: 1px;
            padding: 9px 40px 4px;
            width: 120px;
        }
    }

    .new-data-table-main-wrap {
        tr {
            height: 2.60417vw;
            line-height: 2.60417vw;
            text-align: center;
        }

        .ivu-table-column-center {
            border-right: 0;
            font-weight: 500;
        }

        .ivu-table th {
            background: #f3f7f6;
        }

        .ivu-table td, .ivu-table th {
            border-bottom: 0;
        }

        .ivu-table-wrapper {
            border: 1px solid #efefef;
        }

        .ivu-table-overflowX {
            overflow-x: hidden !important;
        }
        .ivu-table-tip {
            overflow-x: hidden !important;
        }
    }
    .new-data-table-main-wrap .ivu-table th {
        border-bottom: 1px solid #efefef;
    }

    /*偶数行*/
    .ivu-table-stripe-even td {
        background-color: #fff !important;
    }

    /*奇数行*/
    .ivu-table-stripe-odd td {
        background-color: #fafbfd !important;
    }
</style>

